import React from 'react';
import { useTranslation } from 'react-i18next';
import { useStyles } from './styles';
const InventoryWidgetTableHeader = () => {
    const { t } = useTranslation();
    const classes = useStyles();
    return (React.createElement(React.Fragment, null,
        React.createElement("thead", { className: classes.tableHeader },
            React.createElement("tr", null,
                React.createElement("th", { className: classes.description }),
                React.createElement("th", { className: classes.delay }),
                React.createElement("th", { className: classes.alignRight, title: t('common:days_left') }, t('common:days_left')),
                React.createElement("th", { className: classes.alignRight, title: t('widget:percentage_left') }, t('widget:percentage_left')),
                React.createElement("th", { className: classes.alignLeft, title: t('widget:ordering_status') }, t('widget:ordering_status')),
                React.createElement("th", null)))));
};
export default InventoryWidgetTableHeader;
//# sourceMappingURL=InventoryWidgetTableHeader.js.map